import React from 'react'
import PropTypes from 'prop-types'

export const Label = ({ options, labelDefault, value }) => {
  let label = labelDefault || 'Izaberi'

  if (Array.isArray(options)) {
    options.forEach(option => {
      if (option.isGrouped) {
        option.options.forEach(childItem => {
          if (childItem.value === value) label = childItem.label
        })
      } else {
        if (option.value === value) label = option.label
      }
    })
  }

  if (label.length > 25) label = `${label.substr(0, 25).trim()}...`

  return <label className={`${label !== 'Izaberi' ? 'select-dropdown-selected' : ''}`}>{label}</label>
}

Label.propTypes = {
  labelDefault: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.any,
    label: PropTypes.string,
    value: PropTypes.any,
    isGrouped: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.any,
      label: PropTypes.string,
      value: PropTypes.any
    }))
  })).isRequired,
  value: PropTypes.any
}
